module.exports = __webpack_public_path__ + "static/badge-2-770cd7129f82899ce5c03aa889491502.png";